<div [class.message-from-wrapper]='true' [class.first]='first'>
  <div class='speech-bubble'>
    <div>{{ params.message }}</div>
  </div>
  <a class='fixme' *ngIf='params.fixme' (click)='params.fixme()' [innerHTML]='params.fixmeMessage'></a>
</div>
<chatbot-message-back *ngIf="content.backButton" [content]='content' [params]='params'></chatbot-message-back>
